import PropTypes from 'prop-types';
import React from 'react';
import { FACEBOOK_LOGIN_ENABLED } from '../../brands/default/features';
import FacebookButton from '../mediaButtons/FacebookButton';
import GoogleButton from '../mediaButtons/GoogleButton';

const LoginMediaButtons = ({ isLoginPage = false }) => {
  const getMediaButtons = () => {
    if (FACEBOOK_LOGIN_ENABLED) {
      return (
        <>
          <div className="col-12 col-md-6 text-center text-md-right">
            <GoogleButton isLoginPage={isLoginPage} />
          </div>
          <div className="col-12 col-md-6 text-center text-md-left">
            <FacebookButton isLoginPage={isLoginPage} />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="col-12 text-center">
            <GoogleButton isLoginPage={isLoginPage} />
          </div>
        </>
      );
    }
  };

  return <div className="row media-login">{getMediaButtons()}</div>;
};

LoginMediaButtons.propTypes = {
  isLoginPage: PropTypes.bool,
};

export default LoginMediaButtons;
